module.exports = __webpack_public_path__ + "img/truckTrailerFrontRight.5764fd13.svg";